export var PageTheme;
(function (PageTheme) {
    PageTheme["Blue"] = "blue";
    PageTheme["Green"] = "green";
    PageTheme["Orange"] = "orange";
    PageTheme["Yellow"] = "yellow";
    PageTheme["Grey"] = "grey";
})(PageTheme || (PageTheme = {}));
export var ComponentTheme;
(function (ComponentTheme) {
    ComponentTheme["Blue"] = "blue";
    ComponentTheme["Green"] = "green";
    ComponentTheme["Orange"] = "orange";
    ComponentTheme["Yellow"] = "yellow";
    ComponentTheme["Black"] = "black";
    ComponentTheme["White"] = "white";
})(ComponentTheme || (ComponentTheme = {}));
export var ComponentThemeTint;
(function (ComponentThemeTint) {
    ComponentThemeTint["TenPercent"] = "10%";
    ComponentThemeTint["ThirtyPercent"] = "30%";
    ComponentThemeTint["OneHundredPercent"] = "100%";
})(ComponentThemeTint || (ComponentThemeTint = {}));
